// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotJobOrderChange\ApiPilotJobOrderChange.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { LineHandlingCompany, LineHandlingCompanyData, LineHandlingCompanyOptions } from 'data/models/LineHandlingCompany';
import { Location, LocationData, LocationOptions } from 'data/models/Location';
import { Measurement, MeasurementData, MeasurementOptions, NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { Pilot, PilotData, PilotOptions } from 'data/models/Pilot';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';
import { TugCompany, TugCompanyData, TugCompanyOptions } from 'data/models/TugCompany';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';
import { PilotAssignmentChangeAction } from 'server/enums/PilotJobOrderChange';
import { PilotJobOrderChangeType } from 'server/enums/PilotJobOrderChangeType';

// PilotJobOrderChangeData is the class that PilotJobOrderChange serializes to/from
export interface PilotJobOrderChangeData {
    Id : number;
	
    Agent : PCUserData | null;
    AgentId : number;
    Event : EventData | null;
    EventId : number;
    FromLocation : LocationData | null;
    FromLocationId : number;
    NewLineHandlingCompany : LineHandlingCompanyData | null;
    NewLineHandlingCompanyId : number | null;
    NewTugCompany : TugCompanyData | null;
    NewTugCompanyId : number | null;
    OldLineHandlingCompany : LineHandlingCompanyData | null;
    OldLineHandlingCompanyId : number | null;
    OldTugCompany : TugCompanyData | null;
    OldTugCompanyId : number | null;
    Pilot : PilotData | null;
    PilotId : number;
    PilotJobOrder : PilotJobOrderData | null;
    PilotJobOrderId : number;
    ToLocation : LocationData | null;
    ToLocationId : number;
    Vessel : VesselData | null;
    VesselId : number | null;
	
    Action : PilotAssignmentChangeAction;
    EndEstimated : /* ISO8601 */ string;
    Length : MeasurementData;
    NewAirDraft : NullableMeasurementData;
    NewBowThrusterOperational : boolean | null;
    NewCancelledDate : /* ISO8601 */ string | null;
    NewDeepDraft : NullableMeasurementData;
    NewDeepDraftConfirmed : boolean;
    NewEndActual : /* ISO8601 */ string | null;
    NewEndEstimated : /* ISO8601 */ string;
    NewLaborStartTime : /* ISO8601 */ string | null;
    NewPilotConfirmed : boolean;
    NewRemarks : string | null;
    NewStartActual : /* ISO8601 */ string | null;
    NewStartEstimated : /* ISO8601 */ string;
    NewStartTimeConfirmed : boolean;
    OldAirDraft : NullableMeasurementData;
    OldBowThrusterOperational : boolean | null;
    OldCancelledDate : /* ISO8601 */ string | null;
    OldDeepDraft : NullableMeasurementData;
    OldEndActual : /* ISO8601 */ string | null;
    OldEndEstimated : /* ISO8601 */ string;
    OldLaborStartTime : /* ISO8601 */ string | null;
    OldRemarks : string | null;
    OldStartActual : /* ISO8601 */ string | null;
    OldStartEstimated : /* ISO8601 */ string;
    StartEstimated : /* ISO8601 */ string;
    Type : PilotJobOrderChangeType;
}

// PilotJobOrderChangeOptions is the class which may be passed to the PilotJobOrderChange constructor to define optional initial data values
export interface PilotJobOrderChangeOptions {
    Id : number;
	
    Agent? : PCUserOptions | null;
    AgentId? : number;
    Event? : EventOptions | null;
    EventId? : number;
    FromLocation? : LocationOptions | null;
    FromLocationId? : number;
    NewLineHandlingCompany? : LineHandlingCompanyOptions | null;
    NewLineHandlingCompanyId? : number | null;
    NewTugCompany? : TugCompanyOptions | null;
    NewTugCompanyId? : number | null;
    OldLineHandlingCompany? : LineHandlingCompanyOptions | null;
    OldLineHandlingCompanyId? : number | null;
    OldTugCompany? : TugCompanyOptions | null;
    OldTugCompanyId? : number | null;
    Pilot? : PilotOptions | null;
    PilotId? : number;
    PilotJobOrder? : PilotJobOrderOptions | null;
    PilotJobOrderId? : number;
    ToLocation? : LocationOptions | null;
    ToLocationId? : number;
    Vessel? : VesselOptions | null;
    VesselId? : number | null;
	
    Action? : PilotAssignmentChangeAction;
    EndEstimated? : /* ISO8601 */ string;
    Length? : MeasurementOptions;
    NewAirDraft? : NullableMeasurementOptions;
    NewBowThrusterOperational? : boolean | null;
    NewCancelledDate? : /* ISO8601 */ string | null;
    NewDeepDraft? : NullableMeasurementOptions;
    NewDeepDraftConfirmed? : boolean;
    NewEndActual? : /* ISO8601 */ string | null;
    NewEndEstimated? : /* ISO8601 */ string;
    NewLaborStartTime? : /* ISO8601 */ string | null;
    NewPilotConfirmed? : boolean;
    NewRemarks? : string | null;
    NewStartActual? : /* ISO8601 */ string | null;
    NewStartEstimated? : /* ISO8601 */ string;
    NewStartTimeConfirmed? : boolean;
    OldAirDraft? : NullableMeasurementOptions;
    OldBowThrusterOperational? : boolean | null;
    OldCancelledDate? : /* ISO8601 */ string | null;
    OldDeepDraft? : NullableMeasurementOptions;
    OldEndActual? : /* ISO8601 */ string | null;
    OldEndEstimated? : /* ISO8601 */ string;
    OldLaborStartTime? : /* ISO8601 */ string | null;
    OldRemarks? : string | null;
    OldStartActual? : /* ISO8601 */ string | null;
    OldStartEstimated? : /* ISO8601 */ string;
    StartEstimated? : /* ISO8601 */ string;
    Type? : PilotJobOrderChangeType;
}

export class PilotJobOrderChange {
    public Id : DataSignal<number>;
	
    public Agent : DataSignal<PCUser | null>;
    public AgentId : DataSignal<number>;
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public FromLocation : DataSignal<Location | null>;
    public FromLocationId : DataSignal<number>;
    public NewLineHandlingCompany : DataSignal<LineHandlingCompany | null>;
    public NewLineHandlingCompanyId : DataSignal<number | null>;
    public NewTugCompany : DataSignal<TugCompany | null>;
    public NewTugCompanyId : DataSignal<number | null>;
    public OldLineHandlingCompany : DataSignal<LineHandlingCompany | null>;
    public OldLineHandlingCompanyId : DataSignal<number | null>;
    public OldTugCompany : DataSignal<TugCompany | null>;
    public OldTugCompanyId : DataSignal<number | null>;
    public Pilot : DataSignal<Pilot | null>;
    public PilotId : DataSignal<number>;
    public PilotJobOrder : DataSignal<PilotJobOrder | null>;
    public PilotJobOrderId : DataSignal<number>;
    public ToLocation : DataSignal<Location | null>;
    public ToLocationId : DataSignal<number>;
    public Vessel : DataSignal<Vessel | null>;
    public VesselId : DataSignal<number | null>;
	
    public Action : DataSignal<PilotAssignmentChangeAction>;
    public EndEstimated : DataSignal<TZDate>;
    public Length : Measurement;
    public NewAirDraft : NullableMeasurement;
    public NewBowThrusterOperational : DataSignal<boolean | null>;
    public NewCancelledDate : DataSignal<TZDate | null>;
    public NewDeepDraft : NullableMeasurement;
    public NewDeepDraftConfirmed : DataSignal<boolean>;
    public NewEndActual : DataSignal<TZDate | null>;
    public NewEndEstimated : DataSignal<TZDate>;
    public NewLaborStartTime : DataSignal<TZDate | null>;
    public NewPilotConfirmed : DataSignal<boolean>;
    public NewRemarks : DataSignal<string | null>;
    public NewStartActual : DataSignal<TZDate | null>;
    public NewStartEstimated : DataSignal<TZDate>;
    public NewStartTimeConfirmed : DataSignal<boolean>;
    public OldAirDraft : NullableMeasurement;
    public OldBowThrusterOperational : DataSignal<boolean | null>;
    public OldCancelledDate : DataSignal<TZDate | null>;
    public OldDeepDraft : NullableMeasurement;
    public OldEndActual : DataSignal<TZDate | null>;
    public OldEndEstimated : DataSignal<TZDate>;
    public OldLaborStartTime : DataSignal<TZDate | null>;
    public OldRemarks : DataSignal<string | null>;
    public OldStartActual : DataSignal<TZDate | null>;
    public OldStartEstimated : DataSignal<TZDate>;
    public StartEstimated : DataSignal<TZDate>;
    public Type : DataSignal<PilotJobOrderChangeType>;

    constructor();
    constructor(data : PilotJobOrderChangeOptions);
    constructor(data: PilotJobOrderChangeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Agent = S.value<PCUser | null>(null);
        this.AgentId = jsonableObservable(S.value<number>(data && data.AgentId !== undefined ? data.AgentId : 0));
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.FromLocation = S.value<Location | null>(null);
        this.FromLocationId = jsonableObservable(S.value<number>(data && data.FromLocationId !== undefined ? data.FromLocationId : 0));
        this.NewLineHandlingCompany = S.value<LineHandlingCompany | null>(null);
        this.NewLineHandlingCompanyId = jsonableObservable(S.value<number | null>(data && data.NewLineHandlingCompanyId !== undefined ? data.NewLineHandlingCompanyId : null));
        this.NewTugCompany = S.value<TugCompany | null>(null);
        this.NewTugCompanyId = jsonableObservable(S.value<number | null>(data && data.NewTugCompanyId !== undefined ? data.NewTugCompanyId : null));
        this.OldLineHandlingCompany = S.value<LineHandlingCompany | null>(null);
        this.OldLineHandlingCompanyId = jsonableObservable(S.value<number | null>(data && data.OldLineHandlingCompanyId !== undefined ? data.OldLineHandlingCompanyId : null));
        this.OldTugCompany = S.value<TugCompany | null>(null);
        this.OldTugCompanyId = jsonableObservable(S.value<number | null>(data && data.OldTugCompanyId !== undefined ? data.OldTugCompanyId : null));
        this.Pilot = S.value<Pilot | null>(null);
        this.PilotId = jsonableObservable(S.value<number>(data && data.PilotId !== undefined ? data.PilotId : 0));
        this.PilotJobOrder = S.value<PilotJobOrder | null>(null);
        this.PilotJobOrderId = jsonableObservable(S.value<number>(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
        this.ToLocation = S.value<Location | null>(null);
        this.ToLocationId = jsonableObservable(S.value<number>(data && data.ToLocationId !== undefined ? data.ToLocationId : 0));
        this.Vessel = S.value<Vessel | null>(null);
        this.VesselId = jsonableObservable(S.value<number | null>(data && data.VesselId !== undefined ? data.VesselId : null));
	    
        this.Action = jsonableObservable(S.value<PilotAssignmentChangeAction>(data && data.Action !== undefined ? data.Action : 0));
        this.EndEstimated = jsonableObservable(S.value<TZDate>(data && data.EndEstimated !== undefined ? new TZDate(data.EndEstimated) : new TZDate(0), TZDate.eq));
        this.Length = data && data.Length !== undefined ? new Measurement(data.Length) : new Measurement();
        this.NewAirDraft = data && data.NewAirDraft !== undefined ? new NullableMeasurement(data.NewAirDraft) : new NullableMeasurement();
        this.NewBowThrusterOperational = jsonableObservable(S.value<boolean | null>(data && data.NewBowThrusterOperational !== undefined ? data.NewBowThrusterOperational : null));
        this.NewCancelledDate = jsonableObservable(S.value<TZDate | null>(data && data.NewCancelledDate !== undefined ? data.NewCancelledDate === null ? null : new TZDate(data.NewCancelledDate) : null, TZDate.nullableEq));
        this.NewDeepDraft = data && data.NewDeepDraft !== undefined ? new NullableMeasurement(data.NewDeepDraft) : new NullableMeasurement();
        this.NewDeepDraftConfirmed = jsonableObservable(S.value<boolean>(data && data.NewDeepDraftConfirmed !== undefined ? data.NewDeepDraftConfirmed : false));
        this.NewEndActual = jsonableObservable(S.value<TZDate | null>(data && data.NewEndActual !== undefined ? data.NewEndActual === null ? null : new TZDate(data.NewEndActual) : null, TZDate.nullableEq));
        this.NewEndEstimated = jsonableObservable(S.value<TZDate>(data && data.NewEndEstimated !== undefined ? new TZDate(data.NewEndEstimated) : new TZDate(0), TZDate.eq));
        this.NewLaborStartTime = jsonableObservable(S.value<TZDate | null>(data && data.NewLaborStartTime !== undefined ? data.NewLaborStartTime === null ? null : new TZDate(data.NewLaborStartTime) : null, TZDate.nullableEq));
        this.NewPilotConfirmed = jsonableObservable(S.value<boolean>(data && data.NewPilotConfirmed !== undefined ? data.NewPilotConfirmed : false));
        this.NewRemarks = jsonableObservable(S.value<string | null>(data && data.NewRemarks !== undefined ? data.NewRemarks : null));
        this.NewStartActual = jsonableObservable(S.value<TZDate | null>(data && data.NewStartActual !== undefined ? data.NewStartActual === null ? null : new TZDate(data.NewStartActual) : null, TZDate.nullableEq));
        this.NewStartEstimated = jsonableObservable(S.value<TZDate>(data && data.NewStartEstimated !== undefined ? new TZDate(data.NewStartEstimated) : new TZDate(0), TZDate.eq));
        this.NewStartTimeConfirmed = jsonableObservable(S.value<boolean>(data && data.NewStartTimeConfirmed !== undefined ? data.NewStartTimeConfirmed : false));
        this.OldAirDraft = data && data.OldAirDraft !== undefined ? new NullableMeasurement(data.OldAirDraft) : new NullableMeasurement();
        this.OldBowThrusterOperational = jsonableObservable(S.value<boolean | null>(data && data.OldBowThrusterOperational !== undefined ? data.OldBowThrusterOperational : null));
        this.OldCancelledDate = jsonableObservable(S.value<TZDate | null>(data && data.OldCancelledDate !== undefined ? data.OldCancelledDate === null ? null : new TZDate(data.OldCancelledDate) : null, TZDate.nullableEq));
        this.OldDeepDraft = data && data.OldDeepDraft !== undefined ? new NullableMeasurement(data.OldDeepDraft) : new NullableMeasurement();
        this.OldEndActual = jsonableObservable(S.value<TZDate | null>(data && data.OldEndActual !== undefined ? data.OldEndActual === null ? null : new TZDate(data.OldEndActual) : null, TZDate.nullableEq));
        this.OldEndEstimated = jsonableObservable(S.value<TZDate>(data && data.OldEndEstimated !== undefined ? new TZDate(data.OldEndEstimated) : new TZDate(0), TZDate.eq));
        this.OldLaborStartTime = jsonableObservable(S.value<TZDate | null>(data && data.OldLaborStartTime !== undefined ? data.OldLaborStartTime === null ? null : new TZDate(data.OldLaborStartTime) : null, TZDate.nullableEq));
        this.OldRemarks = jsonableObservable(S.value<string | null>(data && data.OldRemarks !== undefined ? data.OldRemarks : null));
        this.OldStartActual = jsonableObservable(S.value<TZDate | null>(data && data.OldStartActual !== undefined ? data.OldStartActual === null ? null : new TZDate(data.OldStartActual) : null, TZDate.nullableEq));
        this.OldStartEstimated = jsonableObservable(S.value<TZDate>(data && data.OldStartEstimated !== undefined ? new TZDate(data.OldStartEstimated) : new TZDate(0), TZDate.eq));
        this.StartEstimated = jsonableObservable(S.value<TZDate>(data && data.StartEstimated !== undefined ? new TZDate(data.StartEstimated) : new TZDate(0), TZDate.eq));
        this.Type = jsonableObservable(S.value<PilotJobOrderChangeType>(data && data.Type !== undefined ? data.Type : 0));
    }

    static key(obj : PilotJobOrderChange) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotJobOrderChangeOptions) {
        return obj.Id;
    }

    static update(obj : PilotJobOrderChange, data : PilotJobOrderChangeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.AgentId !== undefined) obj.AgentId(data.AgentId);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.FromLocationId !== undefined) obj.FromLocationId(data.FromLocationId);
            if (data.NewLineHandlingCompanyId !== undefined) obj.NewLineHandlingCompanyId(data.NewLineHandlingCompanyId);
            if (data.NewTugCompanyId !== undefined) obj.NewTugCompanyId(data.NewTugCompanyId);
            if (data.OldLineHandlingCompanyId !== undefined) obj.OldLineHandlingCompanyId(data.OldLineHandlingCompanyId);
            if (data.OldTugCompanyId !== undefined) obj.OldTugCompanyId(data.OldTugCompanyId);
            if (data.PilotId !== undefined) obj.PilotId(data.PilotId);
            if (data.PilotJobOrderId !== undefined) obj.PilotJobOrderId(data.PilotJobOrderId);
            if (data.ToLocationId !== undefined) obj.ToLocationId(data.ToLocationId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.Action !== undefined) obj.Action(data.Action);
            if (data.EndEstimated !== undefined) obj.EndEstimated(new TZDate(data.EndEstimated));
            if (data.Length !== undefined) Measurement.update(obj.Length, data.Length);
            if (data.NewAirDraft !== undefined) NullableMeasurement.update(obj.NewAirDraft, data.NewAirDraft);
            if (data.NewBowThrusterOperational !== undefined) obj.NewBowThrusterOperational(data.NewBowThrusterOperational);
            if (data.NewCancelledDate !== undefined) obj.NewCancelledDate(data.NewCancelledDate === null ? null : new TZDate(data.NewCancelledDate));
            if (data.NewDeepDraft !== undefined) NullableMeasurement.update(obj.NewDeepDraft, data.NewDeepDraft);
            if (data.NewDeepDraftConfirmed !== undefined) obj.NewDeepDraftConfirmed(data.NewDeepDraftConfirmed);
            if (data.NewEndActual !== undefined) obj.NewEndActual(data.NewEndActual === null ? null : new TZDate(data.NewEndActual));
            if (data.NewEndEstimated !== undefined) obj.NewEndEstimated(new TZDate(data.NewEndEstimated));
            if (data.NewLaborStartTime !== undefined) obj.NewLaborStartTime(data.NewLaborStartTime === null ? null : new TZDate(data.NewLaborStartTime));
            if (data.NewPilotConfirmed !== undefined) obj.NewPilotConfirmed(data.NewPilotConfirmed);
            if (data.NewRemarks !== undefined) obj.NewRemarks(data.NewRemarks);
            if (data.NewStartActual !== undefined) obj.NewStartActual(data.NewStartActual === null ? null : new TZDate(data.NewStartActual));
            if (data.NewStartEstimated !== undefined) obj.NewStartEstimated(new TZDate(data.NewStartEstimated));
            if (data.NewStartTimeConfirmed !== undefined) obj.NewStartTimeConfirmed(data.NewStartTimeConfirmed);
            if (data.OldAirDraft !== undefined) NullableMeasurement.update(obj.OldAirDraft, data.OldAirDraft);
            if (data.OldBowThrusterOperational !== undefined) obj.OldBowThrusterOperational(data.OldBowThrusterOperational);
            if (data.OldCancelledDate !== undefined) obj.OldCancelledDate(data.OldCancelledDate === null ? null : new TZDate(data.OldCancelledDate));
            if (data.OldDeepDraft !== undefined) NullableMeasurement.update(obj.OldDeepDraft, data.OldDeepDraft);
            if (data.OldEndActual !== undefined) obj.OldEndActual(data.OldEndActual === null ? null : new TZDate(data.OldEndActual));
            if (data.OldEndEstimated !== undefined) obj.OldEndEstimated(new TZDate(data.OldEndEstimated));
            if (data.OldLaborStartTime !== undefined) obj.OldLaborStartTime(data.OldLaborStartTime === null ? null : new TZDate(data.OldLaborStartTime));
            if (data.OldRemarks !== undefined) obj.OldRemarks(data.OldRemarks);
            if (data.OldStartActual !== undefined) obj.OldStartActual(data.OldStartActual === null ? null : new TZDate(data.OldStartActual));
            if (data.OldStartEstimated !== undefined) obj.OldStartEstimated(new TZDate(data.OldStartEstimated));
            if (data.StartEstimated !== undefined) obj.StartEstimated(new TZDate(data.StartEstimated));
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotJobOrderChange.ts